import { useEffect } from 'react';
import { Routes, Route, Outlet } from "react-router-dom";

/*THEME*/
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './tema';
import './scss/general.scss';

/***REDUX****/
import { Provider } from 'react-redux';
import { loadUser } from './actions/auth';
import store from './store';

//Contenedores
import Login from './containers/auth/Login';
import ForgotPass from './containers/auth/ForgotPass';
import SignUp from './containers/auth/SignUp';
import SignUpSteps from './containers/auth/SignUpSteps';
import LastStep from './containers/auth/LastStep';
import Home from './containers/home/Home';
import MiPerfil from './containers/perfil/MiPerfil';
import Investment from './containers/investments/Investment';
import InvestmentWService from './containers/investments/InvestmentWService';
import DetailInvestment from './containers/investments/DetailInvestment';
import RequestInvoice from './containers/investments/RequestInvoice';
import Inversiones from './containers/admin/Inversiones';
import ListAdmin from './containers/investorManagement/ListAdmin';
import ListRequest from './containers/investorManagement/ListRequest';
import ClientDetail from './containers/investorManagement/ClientDetail';
import Empresas from './containers/admin/Empresas';
import AddEmpresa from './containers/admin/AddEmpresa';

//necesarios
import setAuthToken from './utils/setAuthToken';
import GeneralRoute from './components/common/GeneralRoute';
import LayoutSteps from './components/common/LayoutSteps';
import Layout from './components/layout/Layout';

//Landing
import SaberMas from './components/landing/SaberMas';
import TerminosCondiciones from './components/landing/TerminosCondiciones';
import CondicionesUso from './components/landing/CondicionesUso';
import PoliticaPrivacidad from './components/landing/PoliticaPrivacidad';
import PoliticaCookies from './components/landing/PoliticaCookies';
import AcercaDe from './components/landing/AcercaDe';

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route element={<GeneralRoute />}>
            <Route path='/' element={<Login />} />
            <Route path='signup' element={<SignUp />} />
          </Route>

          <Route path='/saber-mas' element={<SaberMas />} />
          <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
          <Route path="/condiciones-uso" element={<CondicionesUso />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/cookies" element={<PoliticaCookies />} />
          <Route path="/acerca-de" element={<AcercaDe />} />

          <Route element={<LayoutSteps />} >
            <Route path='signup-step' element={<SignUpSteps />} />
            <Route path='signup-last' element={<LastStep />} />
            <Route path="forgot-pass" element={<ForgotPass />} />
          </Route>

          <Route element={<Layout><Outlet /></Layout>}>
            <Route path='home' element={<Home />} />
            <Route path='datos-fiscales' element={<MiPerfil />} />
            <Route path='inversiones' element={<Investment />} />
            <Route path='inversiones-con-servicio' element={<InvestmentWService />} />
            <Route path='detalle-inversiones' element={<DetailInvestment />} />
            <Route path='solicitar-factura' element={<RequestInvoice />} />
          </Route>

          <Route path='/admin' element={<Layout><Outlet /></Layout>}>
            <Route path='inversiones' element={<Inversiones />} />
            <Route path='inversionistas' element={<ListAdmin />} />
            <Route path='solicitudes' element={<ListRequest />} />
            <Route path='empresas' element={<Empresas />} />
            <Route path='empresas/nueva' element={<AddEmpresa />} />
            <Route path='empresas/editar/:id' element={<AddEmpresa />} />
            <Route path='detalle/:id' element={<ClientDetail />} />
          </Route>
        </Routes>
      </ThemeProvider>
    </Provider>
  )
}

export default App;